/**
 * Device detection composable
 * Detects device type and capabilities based on user agent and browser features
 */

// Check for touch capability using various methods
// Note: Some properties are non-standard and may not exist in all browsers
type LegacyNavigatorTouchPoints = Navigator & {
  MaxTouchPoints?: number
  msMaxTouchPoints?: number
}

const navigatorWithLegacyTouchPoints = navigator as LegacyNavigatorTouchPoints

const touchable = (
  ('ontouchstart' in window)
  || ((navigatorWithLegacyTouchPoints.MaxTouchPoints ?? 0) > 0)
  || ((navigatorWithLegacyTouchPoints.msMaxTouchPoints ?? 0) > 0)
)

const userAgent = navigator.userAgent.toLowerCase()

const isApple = userAgent.includes('mac os x')
const isAndroid = userAgent.includes('android')
const isIPad = userAgent.includes('ipad')
const isIPhone = userAgent.includes('iphone')

type UseDeviceDetectResult = {
  touchable: boolean
  isApple: boolean
  isAndroid: boolean
  isIPad: boolean
  isIPhone: boolean
}

export const useDeviceDetect = (): UseDeviceDetectResult => {
  return {
    touchable,
    isApple,
    isAndroid,
    isIPad,
    isIPhone,
  }
}

